<template>
  <!-- 自建圖示庫的統一輸出元件：顏色跟隨 currentColor、尺寸預設 1em -->
  <svg
    class="svg-icon"
    :viewBox="icon.viewBox"
    :style="{ width: sizeValue, height: sizeValue }"
    fill="none"
    stroke="currentColor"
    stroke-width="1.8"
    stroke-linecap="round"
    stroke-linejoin="round"
    aria-hidden="true"
    v-html="icon.content"
  />
</template>

<script setup>
import { computed } from 'vue'
import { getIcon } from '@/icons'

const props = defineProps({
  // 圖示名（支援舊的 Element Plus 名稱，會自動對應）
  name: { type: String, default: '' },
  size: { type: [String, Number], default: '1em' }
})

const icon = computed(() => getIcon(props.name))
const sizeValue = computed(() => (typeof props.size === 'number' ? `${props.size}px` : props.size))
</script>

<style scoped>
.svg-icon {
  display: inline-block;
  vertical-align: -0.15em;
  flex-shrink: 0;
}
</style>
